export default __webpack_public_path__ + "static/media/Resources.90e1c980.svg";